<template>
  <input-base ref="input"
              :type="type"
              :value="value"
              :label="label"
              :help="help"
              :error="error"
              @input="inputted"
              @change="changed"
              @blur="blurred"
              @focus="focused"
              @click="clicked"></input-base>
</template>

<style lang="stylus" scoped>
</style>

<script>
  import InputBase from './InputBase.vue'
  export default {
    components: {
      InputBase
    },
    props: {
      error: String,
      help: String,
      label: String,
      value: String,
      type: String
    },
    methods: {
      inputted (e) {
        this.$emit('input', e)
      },
      changed (e) {
        this.$emit('change', e)
      },
      blurred (e) {
        this.$emit('blur', e)
      },
      focused (e) {
        this.$emit('focus', e)
      },
      clicked (e) {
        this.$emit('click', e)
      },
      focus () {
        this.$refs.input.focus()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InputLabelled.vue?67d544a4